<template>
  <div class="event-popup-companies-section">
    <div class="event-popup-companies-section__header">参加企業</div>
    <div class="event-popup-companies-section__body">
      <EventPopupCompanyLogo v-for="company in visibleCompanies" :key="company.id" :logo-url="company.square_logo" />
    </div>
    <div v-if="!viewAll" class="event-popup-companies-section__view-all-wrapper">
      <a class="event-popup-companies-section__view-all" @click.prevent="onViewAll">すべて見る</a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, computed } from '@vue/composition-api';
import { EventCompany } from 'oc2api/popup';
import EventPopupCompanyLogo from './EventPopupCompanyLogo.vue';

export default defineComponent({
  name: 'EventPopup',
  components: {
    EventPopupCompanyLogo,
  },
  props: {
    companies: {
      type: Array as PropType<EventCompany[]>,
      required: true,
    },
  },
  setup(props) {
    const maxCompanies = 12;
    const viewAll = ref(props.companies.length <= maxCompanies);
    const visibleCompanies = computed(() => (viewAll.value ? props.companies : props.companies.slice(0, maxCompanies)));
    const onViewAll = () => {
      viewAll.value = true;
    };
    return {
      visibleCompanies,
      viewAll,
      onViewAll,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-companies-section__header {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-companies-section__body {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.event-popup-companies-section__view-all-wrapper {
  margin-top: 12px;
  text-align: right;
}

.event-popup-companies-section__view-all {
  cursor: pointer;
  color: $oc-primary;
}
</style>
